var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { staticClass: "c-notifications", attrs: { name: "notify", tag: "ul" } },
    _vm._l(_vm.notifications, function(notification, index) {
      return _c(
        "li",
        {
          key: "notification-" + index,
          staticClass: "notification",
          class: "-" + notification.type,
          attrs: { "data-cy": "notification" }
        },
        [
          _c("c-icon", {
            staticClass: "icon",
            attrs: { icon: _vm.getIcon(notification) }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "message",
            domProps: { innerHTML: _vm._s(notification.message) }
          }),
          _vm._v(" "),
          _c("c-button", {
            staticClass: "button",
            attrs: { icon: "cross" },
            on: {
              click: function($event) {
                return _vm.close(notification)
              }
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3edff976", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3edff976","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CNotifications.vue
// module id = vSOM
// module chunks = 1624